module.exports = __webpack_public_path__ + "static/media/corp_solo_5.fbb69b13.png";